import React, { useEffect } from 'react';

import { bemCssModules, getTestId } from '@utils';

import { accountsActions, useStore } from '@modules';
import { IbanStatusesEnum } from '@modules/user/types';

import AccountsExclamation from '@components/AccountsExclamation';
import MainLayout, { TMainLayout } from '@layouts/MainLayout';

import Menu, { TMenu } from './Menu';

import style from './ModalLayoutOld.scss';

const cn = bemCssModules(style, 'ModalLayoutOld');
const ti = getTestId('ModalLayoutOld');

export type TModalLayoutOld = TMainLayout & {
  accountsExclamation?: boolean;
  tabs: TMenu['tabs'];
  onChange?: TMenu['onChange'];
};

const ModalLayoutOld: CustomFC<TModalLayoutOld> = props => {
  const {
    className,
    children,
    accountsExclamation,
    backButton,
    closeButton = true,
    tabs,
    onChange,
  } = props;

  const [{ user, accounts }, dispatch] = useStore();
  const hasAccountsData = !!accounts.details.length;
  const isIbanCreated = user.data?.iban_status === IbanStatusesEnum.created;

  const mainLayoutProps = { backButton, closeButton };
  const menuProps = { tabs, onChange };

  useEffect(() => {
    if (isIbanCreated && !hasAccountsData) dispatch(accountsActions.getAccounts());
  }, [user.data]);

  return (
    <MainLayout className={cn(null, [className])} data-testid={ti()} {...mainLayoutProps}>
      <div className={cn('wrapper')}>
        <div className={cn('menu')}>
          <Menu {...menuProps} />
        </div>
        {accountsExclamation && <AccountsExclamation />}
        <div className={cn('content')}>{children}</div>
      </div>
    </MainLayout>
  );
};

export default ModalLayoutOld;
